export const PROCESSORS = {
    1: 'Clearent',
}

export const PROCESSORS_TYPE = {
    1: 'Credit Card',
    2: 'Debit Card', 
    3: 'ACH',
    4: 'Check',
    5: 'Cash'
}